module.exports = __webpack_public_path__ + "media/components/app-store/static/ios__qr-download-en-09eb9af501b93fc07e5a53a37e0a5030.svg";